"use client";

import { motion } from "motion/react";

export function AboutSection() {
  return (
    <section
      id="about"
      className="relative py-32 md:py-40"
      style={{ backgroundImage: "url('/images/gallery/bg-1-new.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      {/* Clean Black Background - No Parallax */}
      <div className="absolute inset-0 bg-black/50 z-0" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="mb-12"
          >
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="h-[1px] bg-white w-[80px] mx-auto mb-12 origin-center"
            />
            <h2 className="text-white mb-12 tracking-[0.15em] font-light text-xl md:text-4xl lg:text-5xl">
              Gate Eleven Residences
            </h2>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-white text-lg md:text-xl leading-relaxed max-w-5xl mx-auto"
          >
            Gate Eleven is a luxury residential development by Amwaj Development in Dubai, located in District 11, Meydan. Offering elegant living across four thoughtfully designed buildings with serene lagoon views, it combines privacy, comfort, and a refined lifestyle in one of Dubai's most sought-after family-friendly communities.
          </motion.p>

        </div>
      </div>
    </section>
  );
}
